module.exports = __webpack_public_path__ + "ce03da16693dd739d3e01cb1e5574f22.mp3";